import type { ApolloCache } from "@apollo/client"

/** The published preview is a separate snapshot from the editable Path. */
export function invalidateCoverPagePreview(
  cache: ApolloCache<unknown>,
  resourceId: number | null | undefined
) {
  if (!resourceId) return
  const id = cache.identify({ __typename: "Resource", id: resourceId })
  if (id) cache.evict({ id, fieldName: "preview_group" })
}
